import React, {Component} from 'react';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import ReactTable from 'react-table';

export default class GiftCardPurchasesReport extends ReactFireComponent {
  constructor(props) {
    super(props);
    this.state = {
      affiliates: []
    }
  }
  componentWillMount() {
    this.bindAsArray('/affiliates', 'affiliates');
  }
  componentWillUnmount() {
    this.unbind('affiliates');
  }
  render() {
    if(this.state.affiliates.length === 0) return 'Loading...';
    const columns = [
      {Header: 'Organization', accessor: 'organization'},
      {Header: 'Group', accessor: 'group'},
      {Header: 'Packages Sold', accessor: 'sales'}
    ];
    const data = this.state.affiliates
      .filter(aff => aff.giftCardSales && aff.giftCardSales[this.props.expoID] && aff.giftCardSales[this.props.expoID][this.props.showID])
      .map(aff => {
        const sales = Object.keys(aff.giftCardSales[this.props.expoID][this.props.showID]).length;
        return {
          organization: aff.organization,
          group: aff.group,
          sales: sales
        }
      });
    return (
      <div>
        <p className="info-panel">
          The following table reflects purchases made to directly
          support fund-raising affilate groups.  It does not include
          purchases made directly from the fundraising page.
        </p>
        <ReactTable
            columns={columns}
            data={data}
            sortable
            />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/report-list/gift-card-purchases-report.js